import api from '@/util/app-api'

// The admin panel equivalent of the `panel` field (HelpPanel enum) is 0.
const ADMIN_PANEL = 0

class HelpService {
  getHelps() {
    return api.get('site/helps', null, { authHeader: false })
  }

  isAdminPanel(panel) {
    return panel === ADMIN_PANEL || panel === String(ADMIN_PANEL) || panel === 'Admin'
  }
}

export default new HelpService()
